module.exports = __webpack_public_path__ + "img/guali3.35c56f40.jpg";